import { Space } from "antd";

//竖型space布局
const VerticalSpace = ({children}) => {
    return <Space size="middle" direction="vertical" style={{width: '100%'}}>
        {children}
    </Space>
}

export default VerticalSpace